import { StateType } from "./types"

import { ACTIONS, STATES } from "./constants"

import { AllActionsType } from "./actions"

import { exportPdf } from "../_utils"

// REDUCER
export function InterviewBuilderReducer(state: StateType, action: AllActionsType): StateType {
  let _questions, _questionIndex

  switch (action.type) {
    case ACTIONS.LOAD_STATE:
      if (!action.state) return state
      return action.state

    case ACTIONS.RESET_STATE:
      if (!action.statePreset) return state
      return STATES[action.statePreset]

    case ACTIONS.ADD_NEW_QUESTION:
      const _newQuestionId = `${Date.now()}`
      return {
        ...state,
        questions: {
          ...state.questions,
          [_newQuestionId]: {
            id: _newQuestionId,
            category: "Custom",
            textDefault: "",
          },
        },
        interview: {
          ...state.interview,
          questions: [
            _newQuestionId,
            ...state.interview.questions,
          ]
        },
        isEditingQuestionId: _newQuestionId,
      }

    case ACTIONS.ADD_QUESTION_TO_INTERVIEW:
      if (typeof action.index !== "number" || !action.questionId) return state
      _questions = [...state.interview.questions]
      _questions.splice(action.index, 0, action.questionId)
      return {
        ...state,
        interview: {
          ...state.interview,
          questions: _questions,
        }
      }

    case ACTIONS.MOVE_QUESTION_IN_INTERVIEW:
      if (typeof action.index !== "number" || !action.questionId) return state
      _questions = [...state.interview.questions.filter(_qid => _qid !== action.questionId)]
      _questions.splice(action.index, 0, action.questionId)
      return {
        ...state,
        interview: {
          ...state.interview,
          questions: _questions,
        }
      }

    case ACTIONS.PERMANENTLY_DELETE_QUESTION:
      if (!action.questionId) return state
      _questions = { ...state.questions }
      delete _questions[action.questionId]
      return {
        ...state,
        questions: _questions,
        interview: {
          ...state.interview,
          questions: state.interview.questions.filter(_qid => _qid !== action.questionId)
        },
      }

    case ACTIONS.REMOVE_QUESTION_FROM_INTERVIEW:
      if (!action.questionId) return state
      _questions = { ...state.questions }
      // If this Question is totally blank delete it permanently instead of moving to the Library
      if (!state.questions[action.questionId].textDefault && !state.questions[action.questionId].textEdited) {
        delete _questions[action.questionId]
      }
      return {
        ...state,
        questions: _questions,
        interview: {
          ...state.interview,
          questions: state.interview.questions.filter(_qid => _qid !== action.questionId)
        },
      }

    case ACTIONS.TOGGLE_EDITING_QUESTION:
      if (!action.questionId) return state
      return {
        ...state,
        isEditingQuestionId: state.isEditingQuestionId === action.questionId ? undefined : action.questionId,
      }

    case ACTIONS.UPDATE_QUESTION_EDITED_TEXT:
      if (!action.questionId) return state
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.questionId]: {
            ...state.questions[action.questionId],
            textEdited: action.text,
          },
        },
      }

    case ACTIONS.REVERT_QUESTION_EDITED_TEXT:
      if (!action.questionId) return state
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.questionId]: {
            ...state.questions[action.questionId],
            textEdited: undefined,
          },
        },
      }

    case ACTIONS.START_DRAGGING_QUESTION:
      if (!action.questionId) return state
      return {
        ...state,
        isDraggingData: {
          cardClientRect: action.cardClientRect,
          questionId: action.questionId,
          questionIndex: action.questionIndex,
          questionOrigin: action.questionOrigin,
        }
      }

    case ACTIONS.UPDATE_DROP_ZONE_INDEX:
      return {
        ...state,
        isDraggingData: {
          ...state.isDraggingData,
          dropZoneIndex: action.dropZoneIndex,
        }
      }

    case ACTIONS.STOP_DRAGGING_QUESTION:
      if (typeof state.isDraggingData.dropZoneIndex === "number" && action.questionId) {
        _questionIndex = state.interview.questions.indexOf(action.questionId)
        _questions = [...state.interview.questions].filter(qid => qid !== action.questionId)
        _questions.splice(
          // Account for the missing question when applying the new index
          _questionIndex >= 0 && _questionIndex < state.isDraggingData.dropZoneIndex ?
            state.isDraggingData.dropZoneIndex - 1 :
            state.isDraggingData.dropZoneIndex,
          0,
          action.questionId
        )
      }
      return {
        ...state,
        interview: {
          ...state.interview,
          questions: _questions ? _questions : state.interview.questions,
        },
        // Reset the dragging data
        isDraggingData: {
          cardClientRect: undefined,
          dropZoneIndex: undefined,
          questionId: undefined,
          questionIndex: undefined,
          questionOrigin: undefined,
        }
      }

    case ACTIONS.UPDATE_JOB_TITLE_FIELD:
      if (!action.jobTitle) return state
      return {
        ...state,
        interview: {
          ...state.interview,
          jobTitle: action.jobTitle,
        }
      }

    case ACTIONS.EXPORT_TO_PDF:
      // Side effect! this runs a utility script that exports the state as a PDF file
      exportPdf(state)
      return state

    default: return state
  }
}
